/**
 * API Keys
 * 
 * This file contains API key constants for various external services used in the application.
 * The actual keys should be stored in environment variables and not hardcoded here.
 */

export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '';

// You can define default settings for APIs here
export const GOOGLE_MAPS_DEFAULT_OPTIONS = {
  region: 'US',
  language: 'en',
  libraries: ['places'],
};

// Function to check if necessary API keys are present
export function validateApiKeys(): { valid: boolean; missing: string[] } {
  const missingKeys: string[] = [];
  
  if (!GOOGLE_MAPS_API_KEY) {
    missingKeys.push('NEXT_PUBLIC_GOOGLE_MAPS_API_KEY');
  }
  
  return {
    valid: missingKeys.length === 0,
    missing: missingKeys
  };
} 